module.exports = __webpack_public_path__ + "static/media/benefit_placeholder_1.5900baa7.png";